import React from 'react';
import useDropdownContext from '../../dropdown-context';
import { isMobileDisplay } from '~/helpers/device';
export default function useMenuControls({ topRef, label }) {
    const { setSubmenuLabel, setActiveDropdown } = useDropdownContext();
    return React.useMemo(() => {
        function closeMenu() {
            setActiveDropdown({});
        }
        function closeDesktopMenu() {
            if (!isMobileDisplay()) {
                closeMenu();
            }
        }
        function openMenu(event) {
            event.preventDefault();
            setActiveDropdown(topRef);
            setSubmenuLabel(label);
            if (isMobileDisplay()) {
                event.target.blur();
            }
        }
        function openDesktopMenu(event) {
            event.preventDefault();
            if (!isMobileDisplay()) {
                openMenu(event);
            }
        }
        return {
            closeMenu,
            closeDesktopMenu,
            openMenu,
            openDesktopMenu
        };
    }, [label, setActiveDropdown, setSubmenuLabel, topRef]);
}
